import { render, staticRenderFns } from "./MobProduct.vue?vue&type=template&id=49678008&scoped=true&"
import script from "./MobProduct.vue?vue&type=script&lang=js&"
export * from "./MobProduct.vue?vue&type=script&lang=js&"
import style0 from "./MobProduct.vue?vue&type=style&index=0&id=49678008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49678008",
  null
  
)

export default component.exports